import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, Inject, OnInit, ViewChild } from '@angular/core';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';



@Component({
  selector: 'app-edit-customer-name',
  templateUrl: './edit-customer-name.component.html',
  styleUrls: ['./edit-customer-name.component.scss']
})
export class EditCustomerNameComponent implements OnInit {

  nameForm!: FormGroup;
  isSaving = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditCustomerNameComponent>,
    private customerService: CustomerService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    const customer = this.customerService.currentCustomer;

    this.nameForm = this.fb.group({
      firstname: [customer.FirstName, Validators.required],
      middlename: [customer.MiddleName],
      lastname: [customer.LastName, Validators.required]
    });
  }

  saveName(): void {
    if (this.nameForm.invalid) return;

    const payload = {
      FIRSTNAME: this.userService.IsCustomUiChange ? this.nameForm.value.firstname : this.nameForm.value.firstname?.toUpperCase(),
      MIDDLENAME: this.userService.IsCustomUiChange ? this.nameForm.value.middlename : this.nameForm.value.middlename?.toUpperCase(),
      LASTNAME: this.userService.IsCustomUiChange ? this.nameForm.value.lastname : this.nameForm.value.lastname?.toUpperCase()
    };

    this.isSaving = true;

    this.customerService
      .updatecustomername(
        JSON.stringify(payload),
        this.customerService.currentCustomer.PersonCompanyId
      )
      .subscribe({
        next: () => {
          Swal.fire({
            text: 'Customer Name Updated Successfully',
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => this.finishSave());
        },
        error: err => {
          Swal.fire({
            text: err,
            icon: 'error',
            confirmButtonText: 'OK'
          });
          this.isSaving = false;
        }
      });
  }

  private finishSave(): void {
    this.customerService
      .getCustomerById(this.customerService.currentCustomer.Id)
      .subscribe((detailCust: Customer[]) => {
        const tempcust = new Customer();
        tempcust.setUpFromWS(detailCust);

        Object.assign(this.customerService.currentCustomer, {
          Name: tempcust.Name,
          FirstName: tempcust.FirstName,
          MiddleName: tempcust.MiddleName,
          LastName: tempcust.LastName
        });

        this.isSaving = false;
        this.dialogRef.close(true);
      });
  }
}
